#import "../../../../../../../../common/graphql/EntityDocumentsFields.graphql"
mutation AttachTravelAuthorizationDocument(
  $input: AttachTravelAuthorizationDocumentInput!
) {
  attachTravelAuthorizationDocument(input: $input) {
    entityDocuments {
      ...EntityDocumentsFields
    }
  }
}
